module.exports = __webpack_public_path__ + "img/mesto 3.85e05631.png";